// Lib
import React from 'react';

// Components
import TextColorButton from '../../../../workspace/toolbar/components/selectionTools/editorTools/textStylePopup/TextColorButton';

// Hooks
import {
    useActiveTableCallback,
    useActiveTableSelector,
} from '../../bridge/store/hotTableStoreHooks';

// Selectors
import { selectActiveTableCommonTextStyle } from '../store/selectors/activeHotTableSelectors';

// Constants
import {
    BACKGROUND_COLOR_PREFIX,
    TEXT_COLOR_PREFIX,
} from '../../../../components/editor/plugins/textColor/textColorConstants';
import { updateHotTableSelectedCellTextStyle } from '../../bridge/utils/hotInstanceUtils/cell/hotTableCellUpdateUtils';

type TableTextColorButtonProps = {
    preset: string | null;
    customTextColor?: string | null;
    customBackgroundColor?: string | null;
};

const hasNoColourStyle = (currentStyle: string[]): boolean =>
    !currentStyle.some((style) => style.startsWith(TEXT_COLOR_PREFIX) || style.startsWith(BACKGROUND_COLOR_PREFIX));

/**
 * Renders a text colour option that applies whole-cell table text styles.
 */
const TableTextColorButton: React.FC<TableTextColorButtonProps> = (props) => {
    const { preset, customTextColor, customBackgroundColor } = props;

    const currentStyle = useActiveTableSelector(selectActiveTableCommonTextStyle) || [];
    const active = preset ? currentStyle.includes(preset) : hasNoColourStyle(currentStyle);

    const onTextColorClick = useActiveTableCallback(
        (activeTable, textStyle: string | null) => updateHotTableSelectedCellTextStyle(activeTable.instance, textStyle),
        [],
    );

    return (
        <TextColorButton
            active={active}
            color={preset}
            className={preset ? preset.toLowerCase() : 'text-standard'}
            onSelectTextColor={onTextColorClick}
            customTextColor={customTextColor}
            customBackgroundColor={customBackgroundColor}
        />
    );
};

export default TableTextColorButton;
